import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminAccommodations() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/accommodation").then((r) => setRows(r.data.requests)); }, []);
  return (
    <div className="p-4 sm:p-8 max-w-4xl mx-auto">
      <h1 className="font-serif text-3xl" style={{ color: "#0B2D59" }}>Accommodation requests</h1>
      <p className="text-sm" style={{ color: "#475569" }}>
        Private inbox. These are <strong>not</strong> included in any eligibility score or AI summary.
      </p>
      <div className="space-y-3 mt-5">
        {rows.map((r) => (
          <div key={r.id} className="p2p-card p-5">
            <div className="text-xs" style={{ color: "#475569" }}>{new Date(r.ts).toLocaleString()}</div>
            <div className="font-medium mt-1" style={{ color: "#0B2D59" }}>{r.name || "(Anonymous)"} · {r.contact || "no contact provided"}</div>
            <div className="mt-2"><strong>Request:</strong> {r.accommodation_request}</div>
            {r.additional_info && <div className="mt-2"><strong>Additional:</strong> {r.additional_info}</div>}
            <div className="mt-2 text-sm" style={{ color: "#475569" }}>Preferred contact: {r.preferred_contact_method}</div>
          </div>
        ))}
        {rows.length === 0 && <div className="p2p-card p-6 text-center" style={{ color: "#475569" }}>No accommodation requests.</div>}
      </div>
    </div>
  );
}
